module.exports = __webpack_public_path__ + "img/yinshua.1db34c88.png";